module.exports = __webpack_public_path__ + "static/boy-d0e3fe653fea3737436c5bfa0851780c.svg";